import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AddLinkSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AddLinkSVG;
